import React from 'react';

import { useTheme } from '@mui/material/styles';

import AddIcon from '@mui/icons-material/Add';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

const AddActionButton = (props: IBaseActionButtonProps) => {
  const theme = useTheme();
  const { classes } = useStyles(theme);

  return (
    <BaseActionButton {...props} styles={{}}>
      <AddIcon />
    </BaseActionButton>
  );
};

export default AddActionButton;
